import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import KolmoApplication from './KolmoApplication.js'
import RunButton from './cmp/RunButton.js'
import ViewButton from './cmp/ViewButton.js'

let application = new KolmoApplication(process.env.REACT_APP_DEDICATED_SERVER_ADDRESS, true);

ReactDOM.render(<App application={application}/>, document.getElementById('root'));

var interactives = document.querySelectorAll("div.interactive-canvas");

interactives.forEach(function(interactivePanel) {

    if ( interactivePanel.querySelector("textarea.manifest-text") )
    {
        let textAreaID = interactivePanel.querySelector("textarea.manifest-text").id;
        let buttonElement =  interactivePanel.querySelector("span.run-button-placeholder");
        if ( buttonElement )
            ReactDOM.render(<RunButton application={application} textAreaID={textAreaID}/>, buttonElement);

        if ( interactivePanel.querySelector("span.manifest-data-placeholder") )
        {
            let manifestDataHolderID = interactivePanel.querySelector("span.manifest-data-placeholder").id
            buttonElement =  interactivePanel.querySelector("span.render-button-placeholder");
            if ( buttonElement )
                ReactDOM.render(<ViewButton textAreaID={textAreaID} manifestDataHolderID={manifestDataHolderID}/>, buttonElement);
        }
    }
});

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
